import { Pipe, PipeTransform } from '@angular/core';
import { CashSessionStatus } from '../cash-session-status';

/**
 * Returns translation keys (not literal strings) so the badge follows the
 * active locale. Consumers chain with the `translate` pipe:
 *
 *   {{ session.Status | cashSessionStatusLabel | translate }}
 */
const LABEL_KEYS: Record<CashSessionStatus, string> = {
  [CashSessionStatus.Open]: 'TREASURY.CASH.SESSION_STATUS.OPEN',
  [CashSessionStatus.Closing]: 'TREASURY.CASH.SESSION_STATUS.CLOSING',
  [CashSessionStatus.PendingReview]: 'TREASURY.CASH.SESSION_STATUS.PENDING_REVIEW',
  [CashSessionStatus.Closed]: 'TREASURY.CASH.SESSION_STATUS.CLOSED',
};

@Pipe({ name: 'cashSessionStatusLabel', standalone: true, pure: true })
export class CashSessionStatusLabelPipe implements PipeTransform {
  transform(value: CashSessionStatus): string {
    return LABEL_KEYS[value];
  }
}
